// extracted by mini-css-extract-plugin
export default {"homepage":"HomePage_homepage__FicID","nav":"HomePage_nav__HVkYr"};